import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ThemeList, ThemeName, ValidThemes } from './model/theme.model';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly THEME_KEY = 'user-theme';
  private currentTheme: BehaviorSubject<ThemeName> =
    new BehaviorSubject<ThemeName>(ThemeList.DEFAULT);
  public currentTheme$: Observable<ThemeName> =
    this.currentTheme.asObservable();

  public setTheme(theme: ThemeName): void {
    if (!ValidThemes.includes(theme)) {
      theme = ThemeList.DEFAULT;
    }

    this.currentTheme.next(theme);
  }
}
